import { forwardRef } from 'react';
import { Input } from '../../forms/Input';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
const Styles = labelStyles('TextInput', {
    input: (props) => [
        { minWidth: 1 },
        props.isMultiline &&
            withModifier('multiline', {
                height: 'auto',
            }),
        props.isFullWidth &&
            withModifier('fullwidth', {
                width: '100%',
            }),
        props.resize &&
            withModifier(`resize-${props.resize}`, {
                resize: props.resize,
            }),
    ],
});
export const TextInput = forwardRef((props, ref) => {
    const Tag = props.isMultiline ? 'textarea' : 'input';
    return (isolateComponent(Input, Object.assign({}, props, { renderIconAfter: props.isMultiline ? undefined : props.renderIconAfter, renderIconBefore: props.isMultiline ? undefined : props.renderIconBefore }), (inputProps) => (isolateComponent(Tag, Object.assign({}, inputProps, { autoCapitalize: props.autoCapitalize, autoCorrect: props.autoCorrect, css: [inputProps.css, Styles.input(props)], inputMode: props.inputMode, ref: ref, rows: props.isMultiline ? props.rows : undefined, spellCheck: props.spellCheck, type: !props.isMultiline ? props.type : undefined, value: inputProps.value, onChange: inputProps.onChange })))));
});
TextInput.defaultProps = {
    isMultiline: false,
    type: 'text',
    isFullWidth: false,
    size: 'small',
    borderRadius: 3,
};
//# sourceMappingURL=TextInput.js.map
// @zapier/design-system@6.3.0 (1dc71580e)
